import React from "react";
import { GAMES } from "../shared/useLists";

/* Sits in the top bar because that is the one strip on every screen, and
   because which game you are looking at changes what every screen means. Two
   games, so a pair of buttons rather than a dropdown — the choice should be
   visible without being opened. */
const OPTIONS = [
  { id: GAMES.POKEMON, label: "Pokémon" },
  { id: GAMES.ONE_PIECE, label: "One Piece" },
];

export default function GameToggle({ game, onChange }) {
  return (
    <div className="game-toggle" role="group" aria-label="Which game">
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          className={"game-toggle-btn" + (game === o.id ? " game-toggle-btn--on" : "")}
          aria-pressed={game === o.id}
          onClick={() => onChange(o.id)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
